export const type = 'form.arcgisAddress';
